module.exports = __webpack_public_path__ + "img/binek.1ecd47fa.png";